<template>
  <div class="overflow-hidden" data-element="Container" v-bind="$attrs">
    <div class="container">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .container {
    @apply flex flex-col gap-25 py-25;

    @include media("lg") {
      @apply py-16 gap-16;
    }
    @include media("md") {
      @apply py-12 gap-12;
    }
    @include media("sm") {
      @apply py-4 gap-9;
    }
  }
</style>
